import React, {Component} from 'react';
import {Table} from 'antd';
import moment from 'moment';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {queryIncuBusinessRemindOregistapp} from '@api/incubator/business';
import {setWbTabCurrent} from '@store/modules/incubator/wb_tab_current';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
    };
  }

  componentDidMount() {
    const { currentShow } = this.props;
    this.incuUuid = this.props.incuUuid;
    this.current = currentShow.address45Page || 1;
    this.getIncuBusinessRemindOregistapp();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.incuUuid !== this.props.incuUuid) {
      this.incuUuid = nextProps.incuUuid;
      this.props.incuUuid && (this.current = 1);
      this.getIncuBusinessRemindOregistapp();
    }
  }

  getIncuBusinessRemindOregistapp = () => {
    if (!this.incuUuid) {
      return;
    }
    const { pageSize } = this.props;
    queryIncuBusinessRemindOregistapp({
      incubatorUuid: this.incuUuid || '',
      start: this.current || 1,
      limit: pageSize,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataSource: {
            list: res.data.list,
            pagination: {
              total: res.totalSize,
              pageSize,
              current: this.current,
            },
          },
        });
      }
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.current = pagination.current;
    this.getIncuBusinessRemindOregistapp();
    const { currentShow } = this.props;
    currentShow.address45Page = pagination.current;
    this.props.dispatch(setWbTabCurrent(currentShow));
  };

  columns = () => {
    return [
      {
        title: '客户名称',
        dataIndex: 'custom',
        render: (text, record) => {
          return (
            <Link to={`/incubator/${this.incuUuid}/custom/detail/${record.customUuid}`}>
              {record.custom}
            </Link>
          );
        },
      },
      {
        title: '占用地址',
        dataIndex: 'addresses',
        render: (text, record) => {
          return (
            <div>
              {(text || []).map(item => {
                return (
                  <p style={{ marginBottom: '0' }} key={item.uuid}>
                    {item.name}
                  </p>
                );
              })}
            </div>
          );
        },
      },
      {
        title: '交易类型',
        dataIndex: 'type',
        key: 'type',
        render: (text, record) => {
          return <span>{record.settled.price ? '收费注册' : '免费注册'}</span>;
        },
      },
      {
        title: '开始时间',
        dataIndex: 'finishTime',
        key: 'finishTime',
        render: (text, record) => {
          // 这里特殊，流程结束的时间是地址的开始时间
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '关联孵化器合同',
        dataIndex: 'settledUuid',
        key: 'settledUuid',
        render: (text, record) => {
          return (
            <Link to={`/incubator/contract/${record.settled.businessUuid}/info`}>
              {record.settled.isTransfer ? <span style={{ color: 'yellow' }}>转</span> : ''}
              {record.settled.no}
            </Link>
          );
        },
      },
      {
        title: '到期时间',
        dataIndex: 'deadline',
        key: 'deadline',
        render: (text, record) => {
          let day = 0;
          if (record.settled.deadline) {
            day = Math.floor((Date.now() - record.settled.deadline) / 86400000);
          }

          const element =
            day > 0 ? (
              <p style={{ color: 'red', marginBottom: '0' }}>（逾期{day}天）</p>
            ) : (
              <p style={{ marginBottom: '0' }}>（剩余{Math.abs(day)}天）</p>
            );
          return (
            <span>
              {record.settled.deadline
                ? moment.unix(record.settled.deadline / 1000).format('YYYY-MM-DD')
                : ''}
              {day ? element : ''}
            </span>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return (
            <div>
              {record.moveOutInstance ? (
                <div>迁出地址（申请中）</div>
              ) : (
                <div>
                  <Link to={`/incubator/oregistappMoveOut_manage/add/${record.uuid}`}>
                    迁出地址
                  </Link>
                </div>
              )}

              <Link to={`/incubator/oregistapp_manage/open/${record.uuid}`}>查看注册申请</Link>
            </div>
          );
        },
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      // stationSum,
      // addressSum,
    } = this.state;
    const { total } = pagination;
    return (
      <div>
        <div className="tips">
          45天内到期地址(
          <span className="content">{total}个地址</span>)
        </div>
        <Table
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }
}

export default connect(state => ({ currentShow: state.wb_tab_current }))(Index);



// WEBPACK FOOTER //
// ./src/components/incubator/workbench/address/Table45.js